import { API } from 'aws-amplify'


const firmAdminService = {
    update,
    getOne,
    checkEmail,
    getAll,
    create,
    getFirms
}

const myAPI = "adisorProfilesAPI"
const path = '/firmAdmin';


async function getAll() {
    return API.get(myAPI, `${path}/`);
}

async function getOne(params) {
    return API.get(myAPI, `${path}/${params}`);
}

async function getFirms() {
    return API.get(myAPI, `${path}/firm`);
}


async function checkEmail(params) {
    return API.get(myAPI, `${path}/userExists/${params}`);
}

async function update(params, myInit) {
    return API.put(myAPI, `${path}/${params}`, addCurrentUserInfo(myInit));
}

async function create(myInit) {
    return API.post(myAPI, path, myInit);
}

function addCurrentUserInfo(myInit) {
    myInit.body.currentUserId = JSON.parse(localStorage.getItem('user')).id;
    myInit.body.userGroups = JSON.parse(localStorage.getItem('user')).groups;
    return myInit;
}



export default firmAdminService;